(function () {
  var STORAGE_KEY = 'nc-consent-v2';
  var banner = document.getElementById('nc-cookies');
  var dialog = document.getElementById('nc-cookies-dialog');
  if (!banner || !dialog) return;

  var analyticsCb = document.getElementById('nc-cookies-analytics');
  var marketingCb = document.getElementById('nc-cookies-marketing');
  var sessionConsent = null;
  var sessionOverride = false;
  var pendingShopify = null;
  var shopifyTimer = null;
  var dialogTrigger = null;

  function validConsent(state) {
    return state && typeof state === 'object' && !Array.isArray(state) &&
      state.version === 2 && typeof state.analytics === 'boolean' &&
      typeof state.marketing === 'boolean' && typeof state.timestamp === 'number' &&
      Number.isFinite(state.timestamp) && state.timestamp > 0;
  }

  function readStored() {
    if (sessionOverride) return sessionConsent;
    try {
      var stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      return validConsent(stored) ? stored : null;
    } catch (e) { return sessionConsent; }
  }

  function updateGoogle(state) {
    try {
      if (typeof window.gtag !== 'function') return;
      var adConsent = state.marketing ? 'granted' : 'denied';
      window.gtag('consent', 'update', {
        analytics_storage: state.analytics ? 'granted' : 'denied',
        ad_storage: adConsent, ad_user_data: adConsent, ad_personalization: adConsent
      });
    } catch (e) { /* bridge best-effort */ }
  }

  function pushShopifyConsent() {
    if (!pendingShopify) return;
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.setTrackingConsent !== 'function') return;
      var latest = pendingShopify;
      privacy.setTrackingConsent({
        analytics: latest.analytics, marketing: latest.marketing,
        preferences: true, sale_of_data: false
      }, function () { /* bridge best-effort */ });
      if (pendingShopify === latest) pendingShopify = null;
      clearTimeout(shopifyTimer);
      shopifyTimer = null;
    } catch (e) { /* keep latest decision for the ready event */ }
  }

  function applyConsent(state, action) {
    updateGoogle(state);
    // Only visitor actions queue Shopify mutations; never replay storage at boot.
    pendingShopify = { analytics: state.analytics, marketing: state.marketing };
    clearTimeout(shopifyTimer);
    pushShopifyConsent();
    if (pendingShopify) {
      shopifyTimer = setTimeout(function () {
        shopifyTimer = null;
        pushShopifyConsent();
      }, 2000);
    }
    try {
      window.dispatchEvent(new CustomEvent('nc:consent-update', {
        detail: { analytics: state.analytics, marketing: state.marketing, action: action }
      }));
    } catch (e) { /* measurement must not interrupt the visitor */ }
    sendConsentBeacon(state, action);
  }

  document.addEventListener('nc:privacy-ready', pushShopifyConsent);
  document.addEventListener('shopify:consent-tracking-api:loaded', pushShopifyConsent);

  async function sendConsentBeacon(state, action) {
    var timeout;
    try {
      var endpoint = window.NCConsentBeacon && window.NCConsentBeacon.endpoint;
      if (!endpoint) return;
      var body = JSON.stringify({
        t: 'consent', action: action,
        analytics: state.analytics ? 1 : 0, marketing: state.marketing ? 1 : 0,
        ts: Date.now(), path: location.pathname
      });
      // One anonymous measurement per action. No measurement at reload.
      try {
        if (navigator.sendBeacon &&
            navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain' }))) return;
      } catch (e) { /* try fetch if the beacon could not be queued */ }
      var controller = new AbortController();
      timeout = setTimeout(function () { controller.abort(); }, 5000);
      await fetch(endpoint, {
        method: 'POST', body: body, keepalive: true, mode: 'no-cors',
        signal: controller.signal
      });
    } catch (e) { /* includes rejected fetch promises */ }
    finally { clearTimeout(timeout); }
  }

  function save(state, action) {
    state.version = 2;
    state.timestamp = Date.now();
    sessionConsent = state;
    sessionOverride = true;
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
    // Complete the UI independently of third-party bridges.
    hideBanner();
    closeDialog();
    applyConsent(state, action);
  }

  function showBanner() { document.documentElement.classList.add('nc-consent-pending'); }
  function hideBanner() { document.documentElement.classList.remove('nc-consent-pending'); }

  function focusWithoutScroll(element) {
    if (element && typeof element.focus === 'function') element.focus({ preventScroll: true });
  }

  function restoreFocus() {
    var trigger = dialogTrigger;
    if (!trigger) return;
    dialogTrigger = null;
    if (trigger.isConnected && trigger.getClientRects().length) {
      focusWithoutScroll(trigger);
    } else if (document.documentElement.classList.contains('nc-consent-pending')) {
      focusWithoutScroll(banner.querySelector('.nc-cookies__title'));
    } else {
      focusWithoutScroll(document.querySelector('main a[href], main button:not([disabled]), main [tabindex]'));
    }
  }

  function openDialog(trigger) {
    if (dialog.open) return;
    var stored = readStored();
    if (analyticsCb) analyticsCb.checked = !!(stored && stored.analytics);
    if (marketingCb) marketingCb.checked = !!(stored && stored.marketing);
    dialogTrigger = trigger || document.activeElement;
    if (window.NCA11y) {
      window.NCA11y.openDialog(dialog, {
        trigger: dialogTrigger, initialFocus: '#nc-cookies-dialog-title'
      });
    } else if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    focusWithoutScroll(document.getElementById('nc-cookies-dialog-title'));
  }

  function closeDialog() {
    if (!dialog.open && !dialog.hasAttribute('open')) return;
    if (window.NCA11y) window.NCA11y.closeDialog(dialog, { returnFocus: false });
    else if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    restoreFocus();
  }

  dialog.addEventListener('cancel', function (event) {
    event.preventDefault();
    closeDialog();
  });
  dialog.addEventListener('close', restoreFocus);
  dialog.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      event.stopImmediatePropagation();
      event.preventDefault();
      closeDialog();
    } else if (event.key === 'Tab' && typeof dialog.showModal !== 'function') {
      var controls = dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]');
      var first = controls[0];
      var last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === document.getElementById('nc-cookies-dialog-title'))) {
        event.preventDefault(); focusWithoutScroll(last);
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); focusWithoutScroll(first);
      }
    }
  });

  function reset() {
    sessionConsent = null;
    sessionOverride = true;
    pendingShopify = null;
    clearTimeout(shopifyTimer);
    shopifyTimer = null;
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    updateGoogle({ analytics: false, marketing: false });
    showBanner();
  }

  if (readStored()) hideBanner();
  else showBanner();

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-nc-cookies]');
    if (!btn) return;
    var action = btn.getAttribute('data-nc-cookies');
    if (action === 'accept') save({ analytics: true, marketing: true }, 'accept_all');
    else if (action === 'reject') save({ analytics: false, marketing: false }, 'reject_all');
    else if (action === 'customize') openDialog(btn);
    else if (action === 'close') closeDialog();
    else if (action === 'save') {
      save({
        analytics: !!(analyticsCb && analyticsCb.checked),
        marketing: !!(marketingCb && marketingCb.checked)
      }, 'customize_save');
    }
  });

  window.NCCookies = { openDialog: openDialog, reset: reset, getConsent: readStored };
  window.__ncCookiesReady = true;
})();
